import { cx } from "@/utils";

export default function SidebarSpacer({ className, ...props }) {
  return (
    <div
      aria-hidden="true"
      {...props}
      className={cx("mt-8 flex-1", className)}
    />
  );
}
